import { useEffect } from "react";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Stats from "../components/Stats";
import Manifesto from "../components/Manifesto";
import Quiz from "../components/Quiz";
import CtaBanner from "../components/CtaBanner";

const HomePage = () => {
  useEffect(() => {
    document.title = "MEDAS Dental Point Timișoara | Clinică dentară din 2019";
  }, []);

  return (
    <>
      <Hero />
      <Marquee />
      <Stats />
      <Manifesto />
      <Quiz />
      <CtaBanner />
    </>
  );
};

export default HomePage;
